export default __webpack_public_path__ + "static/pricecrises-a6cb514aaa0cf2ff567ddaef9a6ddd3f.png";